export default __webpack_public_path__ + "static/media/avatar.d6b73abd.png";